import axios from 'axios'

export default{ 
    namespaced: true,
    state: {
        questionList: null,
        error: null,
        mockResponse: null,
    },

    getters: {
        questions(state){
            return state.questionList;
        },
        getError(state){
            return state.error;
        },
        UserMockResponse(state){
            return state.mockResponse
        },
    },

    actions: {
        async fetchQuestion({ dispatch }, url) {
            //console.log(url)
            const response = await axios.get(url)
            //console.log(response)
            if(response.data.success != 1){
                dispatch('setErrror', response.data.message)
            }
            else{
            dispatch('passQuestion', response.data)
            dispatch('setErrror', '')
            }
        },
        async saveMockForUser({ dispatch }, data){
            const response = await axios.post(data.url,data)
            if(response != undefined){
                //console.log(response)
                if(response.data.success != 1){
                    console.log(response.data.message)
                    dispatch('setErrror', response.data)
                }
                else{
                dispatch('passUserMockResponse', response.data)
                dispatch('setErrror', '')
                }
            }
        },
        async passQuestion(context, data){
            try{
                //console.log(data)
                context.commit('SET_QUESTIONS', data)
            }
            catch(e){
                //console.log('failed')
            }
        },
        passUserMockResponse(context, data){
            try{
                ////console.log(data)
                context.commit('SET_USER_MOCK_RESPONSE', data)
            }
            catch(e){
                ////console.log('failed')
            }
        },
        async setErrror(context,err){
            context.commit('SET_ERROR', err)
        },
        async postAnswer(url, params){
            let res = await axios.post(url, params);
            console.log(res.data);
        }
    },

    mutations: {
        SET_QUESTIONS(state,list){
            state.questionList = list
        },
        SET_USER_MOCK_RESPONSE(state,list){
            state.mockResponse = list
        },
        SET_ERROR(state,data){
            state.error = data
        }
    }

}